<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Image') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Optional_information_upload_image') }}</p>        
    <div class="multisteps-form__content mt-4">
      <div class="row">
        <div class="col-12">
          <div id="animalImgs" class="form-control border dropzone"></div>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from "dropzone";
import { ref, onMounted, defineExpose } from 'vue'

export default {
  name: "ImageSection",
  props: {
    formData: Object,
    emitter: Object,
  },
  setup(props) {
    const dropzone = ref(null);
    const dropzoneElementId = "#animalImgs";

    const initializeDropzone = () => {    
      if (dropzone.value) return; // Prevent re-initialization

      Dropzone.autoDiscover = false;

      dropzone.value = new Dropzone(document.querySelector(dropzoneElementId), {      
        url: "https://httpbin.org/post", // Dummy URL
        maxFiles: 5,
        maxFilesize: 5, // in MB
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",

        init: function () {

          this.on("addedfiles", () => {
            const files = this.getAcceptedFiles();
            console.log("All added files:", files.map(f => f.name));
            if (props.emitter) {
              props.emitter.emit("animalImageUploaded", files);
            }
          });

          this.on("removedfile", () => {
            const files = this.getAcceptedFiles();
            if (props.emitter) {
              props.emitter.emit("animalImageUploaded", files);
            }
          });
        }
      });
    };

    const processQueue = () => {
      dropzone.value?.processQueue();
    };

    const getQueuedFiles = () => {
      return dropzone.value?.getQueuedFiles() || [];
    };

    onMounted(() => {
      initializeDropzone();
    });
    
    defineExpose({
      processQueue,
      getQueuedFiles
    });

    return {
      
    };
  }
};
</script>